
import Config from 'global-libs/config/config';
import CoolFetch from 'global-libs/fetch/cool-fetch';
export default {
    getAvailableTypes: (callback) => {
        // SimpleFetch.get(Config.getConfig('root'),{
        //     "r":"resource",
        //     "i":"getAvailableTypes",
        // })
        //     .then((result)=>{
        //         console.log(JSON.stringify(result));
        //         callback(result);
        //     },(errMessage)=>{
        //         console.log(errMessage);
        //         callback({tag:0,info:errMessage});
        //     })

        CoolFetch.get(Config.getConfig('root') + "/res_type.json")
            .then((result) => {
                // console.log(JSON.stringify(result));
                callback(result);
            }, (errMessage) => {
                console.log(errMessage);
                callback({ tag: 0, info: errMessage });
            })
    },
    getResByType: async (typeID, callback) => {
        // SimpleFetch.get(Config.getConfig('root'),{
        //     "r":"resource",
        //     "i":"getRes",
        //     "type_id":typeID
        // })
        //     .then((result)=>{
        //         console.log(JSON.stringify(result));
        //         callback(result);
        //     },(errMessage)=>{
        //         console.log(errMessage);
        //         callback({tag:0,info:errMessage});
        //     })

        // CoolFetch.get(Config.getConfig('root')+"/res_type"+typeID+".json")
        //     .then((result)=>{
        //         console.log(JSON.stringify(result));
        //         callback(result);
        //     },(errMessage)=>{
        //         console.log(errMessage);
        //         callback({tag:0,info:errMessage});
        //     })

        if (!Config.getConfig('tool') && !Config.getConfig('video')) {
            let dataUrl = `https://tcb-itiwx2hhe8t2ys3-9ciy42e72a4e.service.tcloudbase.com/guangkeguan/getToolData`;
            try {
                let result = await CoolFetch.get(dataUrl);
                if (result && result.tool && result.video) {
                    Config.addConfig("tool", result.tool);
                    Config.addConfig("video", result.video);
                }
                if (typeID === '1') {
                    callback(result.tool);
                    // console.log(result.tool);
                } else if (typeID === '2') {
                    callback(result.video);
                    // console.log(result.video);
                }
            } catch (e) {
                callback({ tag: 0, info: e });
            }
        } else {
            if (typeID === '1') {
                callback(Config.getConfig('tool'));
            } else if (typeID === '2') {
                callback(Config.getConfig('video'));
            }
        }
    }
}